import { CartUpdatedEvent } from '@theme/events';

class CannaWalletColor extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.select = this.querySelector('select');
    this.status = this.querySelector('[role="status"]');
    this.select.addEventListener('change', () => this.changeColor());
  }

  async changeColor() {
    const nextId = this.select.value;
    if (this.busy || nextId === this.dataset.variantId) return;
    if (!Array.from(this.select.options, option => option.value).includes(nextId)) return;
    this.busy = true;
    this.select.disabled = true;
    this.setAttribute('aria-busy', 'true');
    this.status.textContent = '';
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Impossible de vérifier votre panier.');
      const cart = await response.json();
      const current = cart.items.find(item => item.key === this.dataset.lineKey) ||
        cart.items.find(item => String(item.variant_id) === this.dataset.variantId && String(item.product_id) === this.dataset.productId);
      if (!current) throw new Error('Le panier a changé. Actualisez la page.');
      const other = cart.items.filter(item => String(item.variant_id) === nextId).reduce((sum, item) => sum + item.quantity, 0);
      const updates = { [current.key]: 0, [nextId]: current.quantity + other };
      const drawer = this.closest('cart-drawer');
      const sections = ['auto-gifts'];
      if (drawer?.dataset.sectionId) sections.push(drawer.dataset.sectionId);
      const update = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: sections.join(','), sections_url: location.pathname })
      });
      const data = await update.json();
      if (!update.ok || data.errors || data.status >= 400) throw new Error(data.description || 'Cette couleur est indisponible. Veuillez réessayer.');
      this.dataset.variantId = nextId;
      if (drawer) {
        document.dispatchEvent(new CartUpdatedEvent({}, {
          itemCount: data.item_count,
          source: 'canna-wallet-color',
          sections: data.sections
        }));
      } else {
        location.reload();
      }
    } catch (error) {
      this.select.value = this.dataset.variantId;
      this.status.textContent = error.message || 'Le changement de couleur a échoué.';
    } finally {
      this.busy = false;
      this.select.disabled = false;
      this.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('canna-wallet-color')) customElements.define('canna-wallet-color', CannaWalletColor);
